import { Button } from "react-bootstrap";
import { smoothScrollToTop } from "../../../hooks/utils/CommonUtils";


export default function ToTopHandButton(){
    return (
        <Button 
            className="btn btn-light" 
            style={{
                borderRadius: "50%", 
                width: "67px", 
                height: "67px",
                display: "flex",
                justifySelf: "end",
                alignItems: "center",
                justifyContent: "center",
                border: "none",
                fontSize: 33
            }}
            type="button"
            onClick={() => smoothScrollToTop()}
        >
            👆
        </Button>
    );
}